import React, { Fragment } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Spinner } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import PaginationComponent from "../components/PaginationComponent";
import MyDateDisplay from "../components/MyDateDisplay";

import { useDispatch, useSelector } from "react-redux";
import * as notificationActions from "../actions/NotificationActions";

const NotificationSearchScreen  = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const loading = useSelector((state) => state.notification.loading);
    const list = useSelector((state) => state.notification.list);
    const filter = useSelector((state) => state.notification.filter);

    const doSearch = () => {
        var copy_filter = createDeepClone(filter);
        
        if(copy_filter.pageIndex == 1) {
            dispatch(notificationActions.loadNotificationSearch(filter, navigate));
        }
        else {
            copy_filter.pageIndex = 1;
            dispatch(notificationActions.setNotificationFilter(copy_filter));
        }
    }

    React.useEffect(() => {
		dispatch(notificationActions.loadNotificationSearch(filter, navigate));
    }, [filter.pageIndex]);

    const onFilterChange = (name, value) => {
        var copy_filter = createDeepClone(filter);
        copy_filter[name] = value;
        dispatch(notificationActions.setNotificationFilter(copy_filter));
    }
    
    const onPageChange = (page) => {
        var copy_filter = createDeepClone(filter);
        copy_filter.pageIndex = page;
        dispatch(notificationActions.setNotificationFilter(copy_filter));
    }

    const onViewNotification = (item) => {
        if(item.active === true) { 
            dispatch(notificationActions.saveNotification(item.id, false, null));
        }

        if(item.refName === "TICKET") {
            navigate('/request-edit/' + item.refId);
        }
        else if(item.refName === "ISO_REQUEST") {
            navigate('/iso-request-edit/' + item.refId);
        }
        else if(item.refName === "INE_REQUEST") {
            navigate('/ine-request-edit/' + item.refId);
        }
        else if(item.refName === "IDI_PROJECT") {
            navigate('/idi-project-edit/' + item.refId);
        }
        else if(item.refName === "IDI_INSPECTION") {
            navigate('/idi-inspection-edit/' + item.refId);
        }
        else if(item.refName === "PAYMENT") {
            navigate('/payment-edit/' + item.refId);
        }
        else if(item.refName === "USER") {
            navigate('/user-edit/' + item.refId);
        }
        else if(item.refName === "COMPANY") {
            navigate('/company-edit/' + item.refId);
        }
    }

    const onActiveChange = (index, item, value) => {
        list.dataList[index].active = value;
        dispatch(notificationActions.saveNotification(item.id, value, list));
    }
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Notification Search" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-3">
                                        <Col xxl={6} md={12}>
                                            <div className="search-box">
                                                <input type="text" className="form-control search" placeholder="Search for notifications..."
                                                    value={filter.search}
                                                    onChange={e => onFilterChange("search", e.target.value)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <select className="form-select"
                                                value={filter.active}
                                                onChange={e => onFilterChange("active", e.target.value)}
                                            >
                                                <option value={""}>All</option>
                                                <option value={true}>Unread</option>
                                                <option value={false}>Read</option>
                                            </select>
                                        </Col>
                                        <Col xxl={2} md={12}>
                                            <button type="button" className="btn btn-primary me-1 w-100" 
                                                disabled={loading}
                                                onClick= {() => doSearch()}
                                            >
                                                <i className="ri-search-eye-line"></i> Search
                                            </button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardLoader loading={loading} />
                                <CardBody>
                                    <div className="table-responsive table-card">
                                        <Table className="table-hover align-middle mb-0">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Notification</th>
                                                    <th style={{width:100}}>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.dataList.map(function(item, index){
                                                    return(
                                                        <tr key={index}>
                                                            <td>
                                                                <span style={{cursor:"pointer"}}
                                                                    onClick={() => onViewNotification(item)}
                                                                >
                                                                    <span className={item.active ? "fw-bold" : ""}>{item.description}</span>
                                                                    <div className="text-gray-600"><MyDateDisplay value={item.dateAdded} /></div>
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="form-check form-switch">
                                                                    <input className="form-check-input" type="checkbox"
                                                                        checked={item.active}
                                                                        onChange={e => onActiveChange(index, item, e.target.checked)}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <Row>
                                        <Col lg={12}>
                                            <PaginationComponent
                                                total={list.totalCount}
                                                currentPage={filter.pageIndex}
                                                onPageChange={page => onPageChange(page)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
}

export default NotificationSearchScreen;